import { InvoiceSummaryDto } from 'src/generated/services/TFinancialApi';

export const isInvoiceProcessing = (invoiceSummary: InvoiceSummaryDto) => invoiceSummary?.shipmentList?.PROCESSING?.length > 0 || !invoiceSummary?.status;

/**
 * Check if a specific shipment is under review
 * @param invoiceSummary - The invoice summary containing shipment lists
 * @param shipmentInvoiceId - The specific shipment invoice ID to check
 * @returns true if the specific shipment is in the UNDER_REVIEW list
 */
export const isShipmentUnderReview = (invoiceSummary: InvoiceSummaryDto, shipmentInvoiceId?: string) => {
  if (!shipmentInvoiceId || !invoiceSummary?.shipmentList?.UNDER_REVIEW) {
    return false;
  }

  return invoiceSummary.shipmentList.UNDER_REVIEW.some((shipment) => shipment.shipmentInvoiceId === shipmentInvoiceId);
};

/**
 * Check if one of the shipments in the invoice summary is under review
 * @param invoiceSummary - The invoice summary containing shipment lists
 * @returns true if any shipment in the UNDER_REVIEW list
 */
export const isAnyShipmentUnderReview = (invoiceSummary: InvoiceSummaryDto) => {
  return invoiceSummary?.shipmentList?.UNDER_REVIEW?.length > 0;
};
